/**
 * adminToolsBridgeApi — read-only endpoints served by mlist-api (staff JWT).
 */

import { mlistFetchJson } from "../mlistClient";

export async function getListingOwnerRelationship(listingId) {
  const { data } = await mlistFetchJson(
    `admin-tools/listings/${listingId}/owner/`
  );
  return data;
}

export async function getUserRelationshipGraph(userId) {
  const { data } = await mlistFetchJson(
    `admin-tools/users/${userId}/relationship-graph/`
  );
  return data;
}

